import type { UnifiedProductRating } from '@noths/polaris-client-unified-product-service';

import type { ProductRatings } from 'src/redux/product/types';

/**
 * Narrows UPS ratings to the case worth showing: a product with at least one
 * rating and an average to go with it. Anything else becomes `null` so
 * consumers have a single "no rating" case to handle rather than three.
 */
export const adaptUnifiedProductRatingsToStore = (
  ratings: UnifiedProductRating | null | undefined,
): ProductRatings | null => {
  if (!ratings || typeof ratings.averageRating !== 'number' || ratings.ratingCount < 1) {
    return null;
  }

  return { averageRating: ratings.averageRating, ratingCount: ratings.ratingCount };
};
